import styled from 'styled-components';

export const StyledPrice = styled.p`
  font-size: 40px;
  color: #000b33;
  font-weight: bold;
`;

export const StyledBadge = styled.div`
  .Polaris-Badge {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  .Polaris-Text--bodySm {
    font-weight: 600 !important;
    font-size: 10px !important;
  }
`;

interface StyledBoxProps {
  isActive?: boolean; 
}

export const StyledBox = styled.div<StyledBoxProps>`
  margin-top: 16px;
  .Polaris-Box {
    margin-top: 16px;
    transition: all 0.3s ease;
    pointer-events: ${({ isActive }) => isActive ? 'none' : ''};

    &:hover {
      opacity: ${({ isActive }) => isActive ? 1 : 0.85} ;
      cursor: ${({ isActive }) => isActive ? '' : 'pointer'};
    }
  }
`;

export const StyledCard = styled.div`
  &.Polaris-Box {
    display: flex !important;
  }
`

export const StyledTextInclude = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
`

export const StyledBadgeSmall = styled.div`
  .Polaris-Text--bodySm {
    font-size: 10px !important;
  }
`

export const StyledDescription = styled.div`
  .Polaris-Text--bodyMd {
    height: 60px;
  }
`

